import { generateCreateActionCreator, generateReadOneActionCreator } from 'actions/crudActionCreators';
import ACTION_NAMES from 'actions/ACTION_NAMES';
import routes from 'actions/routes';

const readHistory = generateReadOneActionCreator(routes.API_HISTORY, ACTION_NAMES.HISTORY);
const createHistory = generateCreateActionCreator(routes.API_HISTORY, ACTION_NAMES.HISTORY);

export default {
    readHistory,
    createHistory
};
